/**
 * Componente del modal que se muestra cuando se pincha en el botón de 'Más modelos', mostrando
 * todos los modelos disponibles.
 **/

import React, { useState, useEffect } from "react";
import { Modal, Dropdown, DropdownButton } from "react-bootstrap";
import "../assets/ModalMain.css";

//imports de imagenes de camiseta manga corta
import AdolescenteH1 from "../assets/imagenesIA/Adolescente-H 1.jpg";
import AdolescenteH2 from "../assets/imagenesIA/Adolescente-H 2.jpg";
import AdolescenteH3 from "../assets/imagenesIA/Adolescente-H 3.jpg";
import AdolescenteH4 from "../assets/imagenesIA/Adolescente-H 4.jpg";
import AdolescenteM1 from "../assets/imagenesIA/Adolescente-M 1.png";
import AdolescenteM2 from "../assets/imagenesIA/Adolescente-M 2.png";
import AdolescenteM3 from "../assets/imagenesIA/Adolescente-M 3.png";
import AdolescenteM4 from "../assets/imagenesIA/Adolescente-M 4.png";
import Anciana1 from "../assets/imagenesIA/Anciana 1.png";
import Anciana2 from "../assets/imagenesIA/Anciana 2.png";
import Anciana3 from "../assets/imagenesIA/Anciana 3.png";
import Anciana4 from "../assets/imagenesIA/Anciana 4.png";
import Anciano1 from "../assets/imagenesIA/Anciano 1.png";
import Anciano2 from "../assets/imagenesIA/Anciano 2.png";
import Anciano3 from "../assets/imagenesIA/Anciano 3.png";
import Anciano4 from "../assets/imagenesIA/Anciano 4.png";
import Hombre1 from "../assets/imagenesIA/Hombre 1.jpg";
import Hombre2 from "../assets/imagenesIA/Hombre 2.jpg";
import Hombre3 from "../assets/imagenesIA/Hombre 3.png";
import Hombre4 from "../assets/imagenesIA/Hombre 4.png";
import Mujer1 from "../assets/imagenesIA/Mujer 1.jpg";
import Mujer2 from "../assets/imagenesIA/Mujer 2.jpg";
import Mujer3 from "../assets/imagenesIA/Mujer 3.png";
import Mujer4 from "../assets/imagenesIA/Mujer 4.png";
import Niña1 from "../assets/imagenesIA/Niña 1.png";
import Niña2 from "../assets/imagenesIA/Niña 2.png";
import Niña3 from "../assets/imagenesIA/Niña 3.png";
import Niña4 from "../assets/imagenesIA/Niña 4.png";
import Niño1 from "../assets/imagenesIA/Niño 1.png";
import Niño2 from "../assets/imagenesIA/Niño 2.jpg";
import Niño3 from "../assets/imagenesIA/Niño 3.png";
import Niño4 from "../assets/imagenesIA/Niño 4.png";

//imports de imagenes de camiseta manga larga
import AD1ML from "../assets/imagenesMangaLarga/AdolescenteH1.png";
import AD2ML from "../assets/imagenesMangaLarga/AdolescenteH2.png";
import AD3ML from "../assets/imagenesMangaLarga/AdolescenteH3.png";
import AD4ML from "../assets/imagenesMangaLarga/AdolescenteH4.png";
import AD5ML from "../assets/imagenesMangaLarga/AdolescenteM1.png";
import AD6ML from "../assets/imagenesMangaLarga/AdolescenteM2.png";
import AD7ML from "../assets/imagenesMangaLarga/AdolescenteM3.png";
import AD8ML from "../assets/imagenesMangaLarga/AdolescenteM4.png";
import ANA1ML from "../assets/imagenesMangaLarga/Anciana1.png";
import ANA2ML from "../assets/imagenesMangaLarga/Anciana2.png";
import ANA3ML from "../assets/imagenesMangaLarga/Anciana3.png";
import ANA4ML from "../assets/imagenesMangaLarga/Anciana4.png";
import ANO1ML from "../assets/imagenesMangaLarga/Anciano1.png";
import ANO2ML from "../assets/imagenesMangaLarga/Anciano2.png";
import ANO3ML from "../assets/imagenesMangaLarga/Anciano3.png";
import ANO4ML from "../assets/imagenesMangaLarga/Anciano4.png";
import HO1ML from "../assets/imagenesMangaLarga/Hombre1.png";
import HO2ML from "../assets/imagenesMangaLarga/Hombre2.png";
import HO3ML from "../assets/imagenesMangaLarga/Hombre3.png";
import HO4ML from "../assets/imagenesMangaLarga/Hombre4.png";
import MU1ML from "../assets/imagenesMangaLarga/Mujer1.png";
import MU2ML from "../assets/imagenesMangaLarga/Mujer2.png";
import MU3ML from "../assets/imagenesMangaLarga/Mujer3.png";
import MU4ML from "../assets/imagenesMangaLarga/Mujer4.png";
import NIA1ML from "../assets/imagenesMangaLarga/Niña1.png";
import NIA2ML from "../assets/imagenesMangaLarga/Niña2.png";
import NIA3ML from "../assets/imagenesMangaLarga/Niña3.png";
import NIA4ML from "../assets/imagenesMangaLarga/Niña4.png";
import NIO1ML from "../assets/imagenesMangaLarga/Niño1.png";
import NIO2ML from "../assets/imagenesMangaLarga/Niño2.png";
import NIO3ML from "../assets/imagenesMangaLarga/Niño3.png";
import NIO4ML from "../assets/imagenesMangaLarga/Niño4.png";

//imports de imagenes con hoodie
import AdolescenteH_Hoodie from "../assets/imagenesHoodie/AdolescenteH_Hoodie.png";
import AdolescenteH_Hoodie2 from "../assets/imagenesHoodie/AdolescenteH_Hoodie2.png";
import AdolescenteH_Hoodie3 from "../assets/imagenesHoodie/AdolescenteH_Hoodie3.png";
import AdolescenteH_Hoodie4 from "../assets/imagenesHoodie/AdolescenteH_Hoodie4.png";
import AdolescenteM_Hoodie from "../assets/imagenesHoodie/AdolescenteM_Hoodie.png";
import AdolescenteM_Hoodie2 from "../assets/imagenesHoodie/AdolescenteM_Hoodie2.png";
import AdolescenteM_Hoodie3 from "../assets/imagenesHoodie/AdolescenteM_Hoodie3.png";
import AdolescenteM_Hoodie4 from "../assets/imagenesHoodie/AdolescenteM_Hoodie4.png";
import AdultoH_Hoodie from "../assets/imagenesHoodie/AdultoH_Hoodie.png";
import AdultoH_Hoodie2 from "../assets/imagenesHoodie/AdultoH_Hoodie2.png";
import AdultoH_Hoodie3 from "../assets/imagenesHoodie/AdultoH_Hoodie3.png";
import AdultoH_Hoodie4 from "../assets/imagenesHoodie/AdultoH_Hoodie4.png";
import AdultoM_Hoodie from "../assets/imagenesHoodie/AdultoM_Hoodie.png";
import AdultoM_Hoodie2 from "../assets/imagenesHoodie/AdultoM_Hoodie2.png";
import AdultoM_Hoodie3 from "../assets/imagenesHoodie/AdultoM_Hoodie3.png";
import AdultoM_Hoodie4 from "../assets/imagenesHoodie/AdultoM_Hoodie4.png";
import Niño_Hoodie from "../assets/imagenesHoodie/Niño_Hoodie.png";
import Niño_Hoodie2 from "../assets/imagenesHoodie/Niño_Hoodie2.png";
import Niño_Hoodie3 from "../assets/imagenesHoodie/Niño_Hoodie3.png";
import Niño_Hoodie4 from "../assets/imagenesHoodie/Niño_Hoodie4.png";
import Niña_Hoodie from "../assets/imagenesHoodie/Niña_Hoodie.png";
import Niña_Hoodie2 from "../assets/imagenesHoodie/Niña_Hoodie2.png";
import Niña_Hoodie3 from "../assets/imagenesHoodie/Niña_Hoodie3.png";
import Niña_Hoodie4 from "../assets/imagenesHoodie/Niña_Hoodie4.png";
import Anciano_Hoodie from "../assets/imagenesHoodie/Anciano_Hoodie.png";
import Anciano_Hoodie2 from "../assets/imagenesHoodie/Anciano_Hoodie2.png";
import Anciano_Hoodie3 from "../assets/imagenesHoodie/Anciano_Hoodie3.png";
import Anciano_Hoodie4 from "../assets/imagenesHoodie/Anciano_Hoodie4.png";
import Anciana_Hoodie from "../assets/imagenesHoodie/Anciana_Hoodie.png";
import Anciana_Hoodie2 from "../assets/imagenesHoodie/Anciana_Hoodie2.png";
import Anciana_Hoodie3 from "../assets/imagenesHoodie/Anciana_Hoodie3.png";
import Anciana_Hoodie4 from "../assets/imagenesHoodie/Anciana_Hoodie4.png";

//imports de imagenes con Pants
import AdultoH_Pants from "../assets/imagenesPants/AdultoH_Pants.png";
import AdultoH_Pants2 from "../assets/imagenesPants/AdultoH_Pants2.png";
import AdultoH_Pants3 from "../assets/imagenesPants/AdultoH_Pants3.png";
import AdultaM_Pants from "../assets/imagenesPants/AdultoM_Pants.png";
import AdultaM_Pants2 from "../assets/imagenesPants/AdultoM_Pants2.png";
import AdultaM_Pants3 from "../assets/imagenesPants/AdultoM_Pants3.png";
import Niño_Pants from "../assets/imagenesPants/Niño_Pants.png";
import Niño_Pants2 from "../assets/imagenesPants/Niño_Pants2.png";
import Niño_Pants3 from "../assets/imagenesPants/Niño_Pants3.png";
import Niña_Pants from "../assets/imagenesPants/Niña_Pants.png";
import Niña_Pants2 from "../assets/imagenesPants/Niña_Pants2.png";
import Niña_Pants3 from "../assets/imagenesPants/Niña_Pants3.png";

// Mantenemos las imágenes en un array de objetos
const modelosDisponibles = [
  { name: "Adolescente-A", img: AdolescenteH1, ropa: "Camiseta m. corta" },
  { name: "Adolescente-B", img: AdolescenteH2, ropa: "Camiseta m. corta" },
  { name: "Adolescente-C", img: AdolescenteH3, ropa: "Camiseta m. corta" },
  { name: "Adolescente-D", img: AdolescenteH4, ropa: "Camiseta m. corta" },
  { name: "Adolescente-E", img: AdolescenteM1, ropa: "Camiseta m. corta" },
  { name: "Adolescente-F", img: AdolescenteM2, ropa: "Camiseta m. corta" },
  { name: "Adolescente-G", img: AdolescenteM3, ropa: "Camiseta m. corta" },
  { name: "Adolescente-H", img: AdolescenteM4, ropa: "Camiseta m. corta" },
  { name: "Anciana-A", img: Anciana1, ropa: "Camiseta m. corta" },
  { name: "Anciana-B", img: Anciana2, ropa: "Camiseta m. corta" },
  { name: "Anciana-C", img: Anciana3, ropa: "Camiseta m. corta" },
  { name: "Anciana-D", img: Anciana4, ropa: "Camiseta m. corta" },
  { name: "Anciano-A", img: Anciano1, ropa: "Camiseta m. corta" },
  { name: "Anciano-B", img: Anciano2, ropa: "Camiseta m. corta" },
  { name: "Anciano-C", img: Anciano3, ropa: "Camiseta m. corta" },
  { name: "Anciano-D", img: Anciano4, ropa: "Camiseta m. corta" },
  { name: "Adulto-A", img: Hombre1, ropa: "Camiseta m. corta" },
  { name: "Adulto-B", img: Hombre2, ropa: "Camiseta m. corta" },
  { name: "Adulto-C", img: Hombre3, ropa: "Camiseta m. corta" },
  { name: "Adulto-D", img: Hombre4, ropa: "Camiseta m. corta" },
  { name: "Adulto-E", img: Mujer1, ropa: "Camiseta m. corta" },
  { name: "Adulto-F", img: Mujer2, ropa: "Camiseta m. corta" },
  { name: "Adulto-G", img: Mujer3, ropa: "Camiseta m. corta" },
  { name: "Adulto-H", img: Mujer4, ropa: "Camiseta m. corta" },
  { name: "Niña-A", img: Niña1, ropa: "Camiseta m. corta" },
  { name: "Niña-B", img: Niña2, ropa: "Camiseta m. corta" },
  { name: "Niña-C", img: Niña3, ropa: "Camiseta m. corta" },
  { name: "Niña-D", img: Niña4, ropa: "Camiseta m. corta" },
  { name: "Niño-A", img: Niño1, ropa: "Camiseta m. corta" },
  { name: "Niño-B", img: Niño2, ropa: "Camiseta m. corta" },
  { name: "Niño-C", img: Niño3, ropa: "Camiseta m. corta" },
  { name: "Niño-D", img: Niño4, ropa: "Camiseta m. corta" },
  { name: "Adolescente-A", img: AD1ML, ropa: "Camiseta m. larga" },
  { name: "Adolescente-B", img: AD2ML, ropa: "Camiseta m. larga" },
  { name: "Adolescente-C", img: AD3ML, ropa: "Camiseta m. larga" },
  { name: "Adolescente-D", img: AD4ML, ropa: "Camiseta m. larga" },
  { name: "Adolescente-E", img: AD5ML, ropa: "Camiseta m. larga" },
  { name: "Adolescente-F", img: AD6ML, ropa: "Camiseta m. larga" },
  { name: "Adolescente-G", img: AD7ML, ropa: "Camiseta m. larga" },
  { name: "Adolescente-H", img: AD8ML, ropa: "Camiseta m. larga" },
  { name: "Anciana-A", img: ANA1ML, ropa: "Camiseta m. larga" },
  { name: "Anciana-B", img: ANA2ML, ropa: "Camiseta m. larga" },
  { name: "Anciana-C", img: ANA3ML, ropa: "Camiseta m. larga" },
  { name: "Anciana-D", img: ANA4ML, ropa: "Camiseta m. larga" },
  { name: "Anciano-A", img: ANO1ML, ropa: "Camiseta m. larga" },
  { name: "Anciano-B", img: ANO2ML, ropa: "Camiseta m. larga" },
  { name: "Anciano-C", img: ANO3ML, ropa: "Camiseta m. larga" },
  { name: "Anciano-D", img: ANO4ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-A", img: HO1ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-B", img: HO2ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-C", img: HO3ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-D", img: HO4ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-E", img: MU1ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-F", img: MU2ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-G", img: MU3ML, ropa: "Camiseta m. larga" },
  { name: "Adulto-H", img: MU4ML, ropa: "Camiseta m. larga" },
  { name: "Niña-A", img: NIA1ML, ropa: "Camiseta m. larga" },
  { name: "Niña-B", img: NIA2ML, ropa: "Camiseta m. larga" },
  { name: "Niña-C", img: NIA3ML, ropa: "Camiseta m. larga" },
  { name: "Niña-D", img: NIA4ML, ropa: "Camiseta m. larga" },
  { name: "Niño-A", img: NIO1ML, ropa: "Camiseta m. larga" },
  { name: "Niño-B", img: NIO2ML, ropa: "Camiseta m. larga" },
  { name: "Niño-C", img: NIO3ML, ropa: "Camiseta m. larga" },
  { name: "Niño-D", img: NIO4ML, ropa: "Camiseta m. larga" },
  { name: "AdolescenteH-A", img: AdolescenteH_Hoodie, ropa: "Hoodie" },
  { name: "AdolescenteH-B", img: AdolescenteH_Hoodie2, ropa: "Hoodie" },
  { name: "AdolescenteH-C", img: AdolescenteH_Hoodie3, ropa: "Hoodie" },
  { name: "AdolescenteH-D", img: AdolescenteH_Hoodie4, ropa: "Hoodie" },
  { name: "AdolescenteM-A", img: AdolescenteM_Hoodie, ropa: "Hoodie" },
  { name: "AdolescenteM-B", img: AdolescenteM_Hoodie2, ropa: "Hoodie" },
  { name: "AdolescenteM-C", img: AdolescenteM_Hoodie3, ropa: "Hoodie" },
  { name: "AdolescenteM-D", img: AdolescenteM_Hoodie4, ropa: "Hoodie" },
  { name: "AdultoH-A", img: AdultoH_Hoodie, ropa: "Hoodie" },
  { name: "AdultoH-B", img: AdultoH_Hoodie2, ropa: "Hoodie" },
  { name: "AdultoH-C", img: AdultoH_Hoodie3, ropa: "Hoodie" },
  { name: "AdultoH-D", img: AdultoH_Hoodie4, ropa: "Hoodie" },
  { name: "AdultoM-A", img: AdultoM_Hoodie, ropa: "Hoodie" },
  { name: "AdultoM-B", img: AdultoM_Hoodie2, ropa: "Hoodie" },
  { name: "AdultoM-C", img: AdultoM_Hoodie3, ropa: "Hoodie" },
  { name: "AdultoM-D", img: AdultoM_Hoodie4, ropa: "Hoodie" },
  { name: "Niño-A", img: Niño_Hoodie, ropa: "Hoodie" },
  { name: "Niño-B", img: Niño_Hoodie2, ropa: "Hoodie" },
  { name: "Niño-C", img: Niño_Hoodie3, ropa: "Hoodie" },
  { name: "Niño-D", img: Niño_Hoodie4, ropa: "Hoodie" },
  { name: "Niña-A", img: Niña_Hoodie, ropa: "Hoodie" },
  { name: "Niña-B", img: Niña_Hoodie2, ropa: "Hoodie" },
  { name: "Niña-C", img: Niña_Hoodie3, ropa: "Hoodie" },
  { name: "Niña-D", img: Niña_Hoodie4, ropa: "Hoodie" },
  { name: "Anciano-A", img: Anciano_Hoodie, ropa: "Hoodie" },
  { name: "Anciano-B", img: Anciano_Hoodie2, ropa: "Hoodie" },
  { name: "Anciano-C", img: Anciano_Hoodie3, ropa: "Hoodie" },
  { name: "Anciano-D", img: Anciano_Hoodie4, ropa: "Hoodie" },
  { name: "Anciana-A", img: Anciana_Hoodie, ropa: "Hoodie" },
  { name: "Anciana-B", img: Anciana_Hoodie2, ropa: "Hoodie" },
  { name: "Anciana-C", img: Anciana_Hoodie3, ropa: "Hoodie" },
  { name: "Anciana-D", img: Anciana_Hoodie4, ropa: "Hoodie" },
  { name: "Niño-A", img: Niño_Pants, ropa: "Pants" },
  { name: "Niño-B", img: Niño_Pants2, ropa: "Pants" },
  { name: "Niño-C", img: Niño_Pants3, ropa: "Pants" },
  { name: "Niña-D", img: Niña_Pants, ropa: "Pants" },
  { name: "Niña-D", img: Niña_Pants2, ropa: "Pants" },
  { name: "Niña-C", img: Niña_Pants3, ropa: "Pants" },
  { name: "Adulto-A", img: AdultoH_Pants, ropa: "Pants" },
  { name: "Adulto-B", img: AdultoH_Pants2, ropa: "Pants" },
  { name: "Adulto-C", img: AdultoH_Pants3, ropa: "Pants" },
  { name: "Adulta-A", img: AdultaM_Pants, ropa: "Pants" },
  { name: "Adulta-B", img: AdultaM_Pants2, ropa: "Pants" },
  { name: "Adulta-C", img: AdultaM_Pants3, ropa: "Pants" },
];

//Se mapean los nombres de las imágenes a categorías para poder filtrar los modelos por edad
const categoryMappings = {
  Niño: ["Niño", "Niña"],
  Adolescente: ["Adolescente"],
  Adulto: ["Adulto", "Adulta"],
  Senior: ["Anciano", "Anciona"],
  Todos: [
    "Niño",
    "Niña",
    "Adolescente",
    "Adulto",
    "Adulta",
    "Anciano",
    "Anciana",
  ],
};

// Todas las categorías de edad posibles
const allAgeOptions = [
  { key: "Niño",     label: "Niño/a"      },
  { key: "Adolescente", label: "Adolescente" },
  { key: "Adulto",   label: "Adulto/a"    },
  { key: "Senior",   label: "Senior"      },
];



const ModalMain = ({ show, onHide, onSeleccionarModelo, tipoRopa, selectedEngine }) => {
  const [edad, setEdad] = useState("Todos");
  const [clickedEdad, setClickedEdad] = useState(false);

  // Ocultar modelos de niños/adolescentes si el motor es GPT 4o
  const hideUnderage = selectedEngine === "GPT 4o";

  // Resetear filtro de edad al cerrar
  useEffect(() => {
    if (!show) {
      const timer = setTimeout(() => {
        setEdad("Todos");
        setClickedEdad(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [show]);

  // Filtrar modelos disponibles
  const filteredStyles = modelosDisponibles.filter((modelo) => {
    // 1) Ocultar menores de edad
    if (
      hideUnderage &&
      (modelo.name.startsWith("Niño") ||
        modelo.name.startsWith("Niña") ||
        modelo.name.startsWith("Adolescente"))
    ) {
      return false;
    }
    // 2) Filtrar por edad
    const matchEdad =
      categoryMappings[edad]?.some((cat) => modelo.name.startsWith(cat)) ?? false;
    // 3) Filtrar por tipo de prenda
    const matchRopa = tipoRopa === "" || modelo.ropa === tipoRopa;
    return matchEdad && matchRopa;
  });

  return (
    <Modal show={show} onHide={onHide} size="xl" centered className="ventana">
      <Modal.Header closeButton className="modal-header">
        <div className="header-row">
          <DropdownButton
            id="dropdown-filtro"
            title={clickedEdad ? edad : "Edad"}
            variant="secondary"
          >
            <Dropdown.Item
              onClick={() => {
                setEdad("Niño");
                setClickedEdad(true);
              }}
            >
              Niño/a
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setEdad("Adolescente");
                setClickedEdad(true);
              }}
            >
              Adolescente
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setEdad("Adulto");
                setClickedEdad(true);
              }}
            >
              Adulto/a
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setEdad("Senior");
                setClickedEdad(true);
              }}
            >
              Senior
            </Dropdown.Item>
          </DropdownButton>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="subestilos-grid">
          {filteredStyles.map((modelo, index) => (
            <div
              className="subestilos-card-container"
              key={index}
              onClick={() => onSeleccionarModelo(modelo)}
            >
              <div className="subestilos-card">
                <img src={modelo.img} alt={modelo.name} />
              </div>
              <p className="subestilos-card-name">{modelo.name}</p>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalMain;
